import { fetchAuthSession } from "aws-amplify/auth";
import { get } from "aws-amplify/api";
import { useQuery } from "react-query";

export const useProfileContactQuery = (patientUserId) => {
  return useQuery({
    queryKey: ["profileContactData", patientUserId],
    retry: false,
    queryFn: async () => {
      const session = await fetchAuthSession();
      const { body } = await get({
        apiName: "pcmedapi",
        path: "/profile/contact/" + patientUserId,
        options: {
          headers: {
            Authorization: session.tokens.idToken.toString(),
          },
        },
      }).response;
      return await body.json();
    },
    enabled: !!patientUserId,
    select: (contact) => {
      const pPhone = contact?.primaryPhone?.split("-") ?? null;
      const sPhone = contact?.secondaryPhone?.split("-") ?? null;
      const wPhone = contact?.workPhone?.split("-") ?? null;
      return {
        ...contact,
        primaryPhone: pPhone ? pPhone[1] : "",
        primaryDialCode: pPhone ? pPhone[0] : "",
        secondaryPhone: sPhone ? sPhone[1] : "",
        secondaryDialCode: sPhone ? sPhone[0] : "",
        workPhone: wPhone ? wPhone[1] : "",
        workDialCode: wPhone ? wPhone[0] : "",
      };
    },
  });
};
